import script from "./InlineConfirmationDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./InlineConfirmationDialog.vue?vue&type=script&setup=true&lang=ts"

import "./InlineConfirmationDialog.vue?vue&type=style&index=0&id=1e5209aa&scope=true&lang=scss"

const __exports__ = script;

export default __exports__